"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button2 = _interopRequireDefault(require("../Button"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var FileUpload = function FileUpload(_ref) {
  var colorType = _ref.colorType,
    isLoading = _ref.isLoading,
    onChange = _ref.onChange,
    buttonLabel = _ref.buttonLabel,
    label = _ref.label,
    name = _ref.name,
    accept = _ref.accept,
    _ref$buttonComponent = _ref.buttonComponent,
    Button = _ref$buttonComponent === void 0 ? _Button2["default"] : _ref$buttonComponent,
    buttonProps = _ref.buttonProps;
  var handleClick = function handleClick() {
    document.getElementById(name).click();
  };
  var handleOnChange = function handleOnChange(event) {
    var file = event.target.files[0];
    onChange(file);
    event.target.value = null;
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Button, _extends({
    type: "button",
    onClick: handleClick,
    colorType: colorType,
    loading: isLoading,
    margin: {
      size: 0
    },
    noMargin: true
  }, buttonProps), buttonLabel || label), /*#__PURE__*/_react["default"].createElement("input", {
    id: name,
    type: "file",
    style: {
      display: 'none'
    },
    name: name,
    onChange: handleOnChange,
    accept: accept
  }));
};
FileUpload.propTypes = {
  colorType: _propTypes["default"].string,
  isLoading: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  label: _propTypes["default"].node,
  buttonLabel: _propTypes["default"].node,
  buttonComponent: _propTypes["default"].func,
  buttonProps: _propTypes["default"].object,
  name: _propTypes["default"].string,
  accept: _propTypes["default"].string
};
var _default = exports["default"] = FileUpload;